import React from 'react'
import ModalTitle from '@/checkout-instore-legacy/components/Commons/ModalTitle'
import Divider from '@vtex/styleguide/lib/Divider'
import CaretRight from '@vtex/styleguide/lib/icon/CaretRight'
import { FormattedMessage } from 'react-intl'

type SocialShareSelectionProps = {
  shareCart: () => void
  sharePayment: () => void
}

type SocialShareOptionProps = {
  label: string
  content: string
  onClick: () => void
}

export const SocialShareSelection = ({
  shareCart,
  sharePayment,
}: SocialShareSelectionProps) => {
  return (
    <div data-testId="shareSelectionShow">
      <ModalTitle id="socialShareTitle" />
      <Divider orientation="horizontal" />

      <SocialShareOption
        label={'socialShareCartLabel'}
        content={'socialShareCartContent'}
        onClick={shareCart}
      />
      <Divider orientation="horizontal" />

      <SocialShareOption
        label={'socialSharePaymentLabel'}
        content={'socialSharePaymentContent'}
        onClick={sharePayment}
      />
      <Divider orientation="horizontal" />
    </div>
  )
}

const SocialShareOption = ({
  label,
  content,
  onClick,
}: SocialShareOptionProps) => {
  return (
    <div
      data-testId={`${label}-div`}
      className="flex mv7 w-100 pointer"
      onClick={onClick}
    >
      <div className="flex flex-column w-90">
        <span className="c-action-primary f4 ">
          <FormattedMessage id={label} />
        </span>
        <span className="mt2 c-muted-1">
          <FormattedMessage id={content} />
        </span>
      </div>
      <div className="w-10 lh-copy c-muted-3 flex  items-center justify-center">
        <CaretRight size={26} />
      </div>
    </div>
  )
}
